// Render plugin for `dashboard_created` SSE events.
// Registered in AgentChatPageV2 config so the agentkit core stays generic.
// Each event carries { dashboardId, customer, config, viewUrl, toolCallId }.

import React from 'react'
import type { RenderPlugin, PluginAgentSSEEvent } from '../agent'
import InlineDashboard from '../components/agent/InlineDashboard'
import type { DashboardConfig } from '../types/gotypes'

interface DashboardEntry {
  dashboardId: string
  customer: string
  config: DashboardConfig
  viewUrl: string
}

// Plugin state: map from dashboardId → dashboard entry for this toolCallId bucket.
type DashboardPluginState = Map<string, DashboardEntry>

export const dashboardPlugin: RenderPlugin<DashboardPluginState> = {
  eventTypes: ['dashboard_created'],

  init(): DashboardPluginState {
    return new Map()
  },

  reduce(state: DashboardPluginState, event: PluginAgentSSEEvent): DashboardPluginState {
    const d = event.data
    const dashboardId = d.dashboardId as string | undefined
    if (!dashboardId) return state
    const next = new Map(state)
    next.set(dashboardId, {
      dashboardId,
      customer: (d.customer as string) || '',
      config: (d.config as DashboardConfig) || {},
      viewUrl: (d.viewUrl as string) || '',
    })
    return next
  },

  render({ state }: { state: DashboardPluginState; toolCallId: string; sessionId: string }) {
    if (state.size === 0) return null
    const dashboards = Array.from(state.values())
    return (
      <>
        {dashboards.map(dash => (
          <InlineDashboard
            key={dash.dashboardId}
            dashboardId={dash.dashboardId}
            customer={dash.customer}
            config={dash.config}
            viewUrl={dash.viewUrl}
          />
        ))}
      </>
    )
  },
}
